module.exports = __webpack_public_path__ + "static/media/PDF_71.e55a4f9b.pdf";